import IconRender from 'components/common/IconRender'
import {
  listingAddressLine,
  listingGeoPointForDisplay,
  ListingAddressSource,
} from 'components/propertyCard/listingAddressLine'
import ListingMapPreviewPopup from 'components/propertyCard/ListingMapPreviewPopup'
import { useState } from 'react'
import { CustomColorsRef, IconSizes } from 'types/general'

type ListingAddressRowProps = {
  property: ListingAddressSource
  className?: string
  fallback?: string
}

const ListingAddressRow = ({
  property,
  className = '',
  fallback,
}: ListingAddressRowProps) => {
  const [isMapOpen, setIsMapOpen] = useState(false)
  const addressLine = listingAddressLine(property) || fallback
  const geoPoint = listingGeoPointForDisplay(property, false)
  const canOpenMap = geoPoint != null

  if (!addressLine) return null

  const openMap = (event: React.MouseEvent) => {
    event.stopPropagation()
    if (canOpenMap) setIsMapOpen(true)
  }

  const rowClassName = `mt-1 flex min-w-0 items-start gap-1.5 text-sm text-left ${
    canOpenMap
      ? 'cursor-pointer text-gray-600 hover:text-imovPrimary'
      : 'text-gray-600'
  } ${className}`

  const content = (
    <>
      <IconRender
        icon="regular-map-location-dot"
        className="mt-0.5 shrink-0"
        size={IconSizes.SM}
        color={canOpenMap ? CustomColorsRef.GrayDark : CustomColorsRef.Gray}
      />
      <span className="min-w-0 leading-snug">{addressLine}</span>
    </>
  )

  return (
    <>
      {canOpenMap ? (
        <button type="button" onClick={openMap} className={rowClassName}>
          {content}
        </button>
      ) : (
        <p className={rowClassName}>{content}</p>
      )}

      <ListingMapPreviewPopup
        isOpen={isMapOpen}
        onClose={() => setIsMapOpen(false)}
        location={geoPoint}
        addressLine={addressLine}
      />
    </>
  )
}

export default ListingAddressRow
